"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var layout_1 = require("../layout");

var select_1 = require("./select");

var text_1 = require("./text");

require("./form.less");

require("./phone.less");

;

var Phone = function (_super) {
  __extends(Phone, _super);

  function Phone(props) {
    var _this = _super.call(this, props) || this;

    var value = props.value;
    _this.state = {
      value: value,
      isValid: false,
      country: "uk",
      countryCode: "44"
    };
    return _this;
  }

  Phone.prototype.onBlur = function () {};

  Phone.prototype.onValue = function (field, newValue, isValid) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, country, phone, value_1, _b, countryCode, value, context, fieldName;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = field;

            switch (_a) {
              case "country":
                return [3
                /*break*/
                , 1];

              case "phone":
                return [3
                /*break*/
                , 3];
            }

            return [3
            /*break*/
            , 5];

          case 1:
            country = newValue;
            return [4
            /*yield*/
            , this.setState({
              country: country
            })];

          case 2:
            _c.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            phone = newValue;

            if (phone.startsWith("0")) {
              value_1 = phone.substring(1);
            } else {
              value_1 = phone;
            }

            return [4
            /*yield*/
            , this.setState({
              value: value_1
            })];

          case 4:
            _c.sent();

            return [3
            /*break*/
            , 5];

          case 5:
            _b = this.state, countryCode = _b.countryCode, value = _b.value;
            context = this.props.context;
            fieldName = this.props.field;
            context.onValue(fieldName, countryCode + " " + value, this.state.isValid);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Phone.prototype.onAction = function (action) {};

  Phone.prototype.render = function () {
    var _this = this;

    var context = this;
    var props = this.props;
    var label = "";

    if (props.label) {
      var className = props.required ? "required" : "";
      label = React.createElement("label", {
        className: className
      }, props.label);
    }

    return React.createElement("div", null, function () {
      if (props.collapsed) {
        return React.createElement("div", {
          className: "input"
        }, label, React.createElement(layout_1.Row, {
          collapsed: true
        }, React.createElement(layout_1.Col, {
          xs: 12
        }, React.createElement(text_1["default"], {
          required: true,
          field: "phone",
          value: _this.state.value,
          placeholder: _this.props.placeholder || "Phone Number",
          validateFn: function validateFn(text) {
            return /^7\d{9}$/.test(text);
          },
          context: _this
        }))));
      } else {
        return React.createElement("div", {
          className: "input"
        }, label, React.createElement(layout_1.Row, {
          collapsed: true
        }, React.createElement(layout_1.Col, {
          xs: 4,
          className: "phone-input"
        }, React.createElement(select_1["default"], {
          field: "country",
          value: _this.state.country,
          context: _this
        }, React.createElement(select_1.SelectOption, {
          value: "uk",
          text: "UK (+44)",
          onSelect: function onSelect() {
            return context.setState({
              countryCode: "44"
            });
          }
        })), React.createElement("div", {
          className: "country-flag " + _this.state.country
        })), React.createElement(layout_1.Col, {
          xs: 8
        }, React.createElement(text_1["default"], {
          required: true,
          field: "phone",
          value: _this.state.value,
          placeholder: _this.props.placeholder || "Phone Number",
          validateFn: function validateFn(text) {
            return /^\d{10}$/.test(text);
          },
          context: _this
        }))));
      }
    }());
  };

  return Phone;
}(React.Component);

exports["default"] = Phone;